import React from "react";
import { Formik, Form, Field } from "formik";
import { Row, Col } from "reactstrap";
import { Button } from "zina-dogi-react";
import AsyncSelect from "react-select/async";
import { service as voaService } from "~/voa";
import { service as voaSummaryService } from "~/voa_summary";
import { service as vendorService } from "~/vendors";
import { service } from "../../redux";
import * as _ from "lodash";

// import { utils } from "../../../../shared";

const titles = ["", "Item", "Material", "Description", "Currency", "Net Price"];
const VoaNumber = React.forwardRef((props, ref) => <AsyncSelect ref={ref} {...props} />);

class VoaFilter extends React.Component {
    state = {
        vendor: null,
        region: null,
        search: "",
        items: [],
        voaOps: []
    };
    formik = React.createRef();

    filterVal = (key, val, filters = {}) => {
        return vendorService
            .getVendors(1, {
                ...filters,
                ...(val !== "" ? { [`${key}__icontains`]: val } : {})
            })
            .then(resp =>
                resp.list.map(val => {
                    return {
                        value: val.id,
                        label: `${val[key]} - ${val.legal_name}`
                    };
                })
            );
    };

    filterValVoa = (key, val, filters = {}) => {
        return voaSummaryService
            .getVoaSummary(1, {
                ...filters,
                ...(val !== "" ? { [`intrastate_voa__${key}__icontains`]: val } : {}),
                intrastate_voa__isnull: false
            })
            .then(resp => {
                const res = resp.list
                    .filter(val => !!val.intrastate_voa)
                    .map(val => ({
                        value: val.intrastate_voa.id,
                        label: val.intrastate_voa[key]
                    }));
                return _.uniqBy(res, "label");
            });
    };

    filterValRegion = (key, val) => {
        return service.getRegions().then(resp =>
            resp.regions.map(val => {
                return {
                    value: val,
                    label: val
                };
            })
        );
    };

    updateVoaNumber = (val, vendor, region) => {
        const filters = {
            ...(vendor ? { vendor } : {}),
            ...(region ? { region } : {})
        };
        if (vendor) {
            return this.filterValVoa("voa_number", val, filters).then(res => {
                this.setState({
                    ...filters,
                    voaOps: res
                });
                return res;
            });
        } else {
            this.setState({
                ...filters,
                voaOps: []
            });
            return Promise.resolve([]);
        }
    };

    get values() {
        return this.formik.current.state.values;
    }

    voaNumberRef = React.createRef();

    render() {
        const { className, run } = this.props;
        const comp_op = {
            className: ["voa_filters", className].join(" ")
        };
        return (
            <div {...comp_op}>
                <div className="content">
                    <Formik
                        ref={this.formik}
                        initialValues={{
                            voa_number: null,
                            vendor: null,
                            region: null,
                            items: []
                        }}
                        onReset={data => {
                            this.setState({
                                vendor: null,
                                region: null,
                                search: "",
                                items: []
                            });
                        }}
                        enableReinitialize={true}
                        onSubmit={(values, cmp) => handleSubmit(this.props.onSubmit, values, cmp)}
                    >
                        {props => {
                            const { values, setFieldValue } = props;
                            return (
                                <Form>
                                    <Row>
                                        <Col sm="12" md="4">
                                            <div className="form-group">
                                                <label>Region</label>
                                                <Field
                                                    name="region"
                                                    value={values.region}
                                                    component={AsyncSelect}
                                                    isClearable
                                                    cacheOptions
                                                    defaultOptions
                                                    loadOptions={val => this.filterValRegion("region", val)}
                                                    onChange={val => {
                                                        setFieldValue("region", val, false);
                                                        setFieldValue("voa_number", null, false);
                                                        this.updateVoaNumber(
                                                            "",
                                                            this.state.vendor,
                                                            val ? val.value : null
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                        <Col sm="12" md="4">
                                            <div className="form-group">
                                                <label>Vendor Code</label>
                                                <Field
                                                    name="vendor_number"
                                                    value={values.vendor}
                                                    component={AsyncSelect}
                                                    isClearable
                                                    cacheOptions
                                                    defaultOptions
                                                    loadOptions={val => this.filterVal("vendor_number", val, { run })}
                                                    onChange={val => {
                                                        setFieldValue("vendor", val, false);
                                                        setFieldValue("voa_number", null, false);
                                                        this.updateVoaNumber(
                                                            "",
                                                            val ? val.value : null,
                                                            this.state.region
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                        <Col sm="12" md="4">
                                            <div className="form-group">
                                                <label>VOA Number</label>
                                                <Field
                                                    isClearable
                                                    defaultOptions
                                                    cacheOptions
                                                    name="voa_number"
                                                    value={values.voa_number}
                                                    component={props => (
                                                        <VoaNumber ref={this.voaNumberRef} {...props} />
                                                    )}
                                                    isDisabled={!this.state.vendor}
                                                    loadOptions={val =>
                                                        this.filterValVoa("voa_number", val, {
                                                            ...(this.state.vendor ? { vendor: this.state.vendor } : {}),
                                                            ...(this.state.region ? { region: this.state.region } : {})
                                                        })
                                                    }
                                                    onChange={val => {
                                                        setFieldValue("voa_number", val, false);
                                                        this.updateTable(val ? val.value : null);
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="controls" style={{ marginTop: "8px" }}>
                                        <div className="form-group" style={{ marginTop: "-16px" }}>
                                            Search:{" "}
                                            <input
                                                id="search"
                                                type="text"
                                                className="form-control"
                                                value={this.state.search}
                                                onChange={ev => {
                                                    const { value } = ev.nativeEvent.target;
                                                    this.setState({ search: value });
                                                }}
                                            />
                                        </div>
                                        <Button type="reset" color="danger" icon="sync-alt">
                                            Clear filters
                                        </Button>
                                    </Row>
                                    <Row>
                                        <Col sm={12} md={12}>
                                            <div
                                                className="table-content"
                                                style={{ overflow: "auto", maxHeight: "400px" }}
                                            >
                                                <table className="table table-bordered table-striped">
                                                    <thead className="thead-dark">
                                                        <tr>
                                                            {titles &&
                                                                titles.map((title, index) => (
                                                                    <th key={`cpo_title_${index}`} scope="col">
                                                                        {title}
                                                                    </th>
                                                                ))}
                                                        </tr>
                                                    </thead>
                                                    <tbody>{this.computeRows(this.state.items)}</tbody>
                                                </table>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                            );
                        }}
                    </Formik>
                </div>
            </div>
        );
    }

    updateTable = voa_id => {
        if (voa_id) {
            voaService.getVoaDetail(voa_id).then(data => {
                this.setState({ items: data.items || [] });
            });
        } else {
            this.setState({ items: [] });
        }
    };

    computeRows = voa_items => {
        if (voa_items) {
            // const non_sode_list = Object.values(non_sodes);
            if (voa_items.length !== 0) {
                const { search } = this.state;
                voa_items = _.filter(
                    voa_items,
                    i =>
                        _.includes(i.material, search) ||
                        _.includes(`${i.item}`, search) ||
                        _.includes(i.description, search)
                );
                voa_items = _.orderBy(voa_items, ["material", "item"], ["asc", "asc"]);
                return voa_items.map((row, index) => {
                    return (
                        <tr key={`non_sode_value_${index}`}>
                            <td className="text-center">
                                <Checkbox name="items" value={row.id} />
                            </td>
                            <td className="text-center">{row.item ? row.item : ""}</td>
                            <td className="text-center">{row.material ? row.material : ""}</td>
                            <td className="text-center">{row.description ? row.description : ""}</td>
                            <td className="text-center">{row.currency ? row.currency : ""}</td>
                            <td className="text-center">{row.net_price ? row.net_price : ""}</td>
                        </tr>
                    );
                });
            }
        }
        return (
            <tr>
                <td colSpan={titles.length}>No data found</td>
            </tr>
        );
    };
}

VoaFilter.header = (
    <nav className="navbar">
        <span className="navbar-brand h4">VOA Management</span>
    </nav>
);

const handleSubmit = (submit, obj, { setSubmitting }) => {
    submit({
        ...(obj.voa_number ? { voa_number__iexact: obj.voa_number.value } : {}),
        ...(obj.vendor ? { vendor: obj.vendor.value } : {})
    });
    setSubmitting(false);
};

function Checkbox(props) {
    return (
        <Field name={props.name}>
            {({ field, form }) => (
                <label>
                    <input
                        {...field}
                        type="checkbox"
                        checked={field.value.includes(props.value)}
                        onChange={() => {
                            const set = new Set(field.value);
                            if (set.has(props.value)) {
                                set.delete(props.value);
                            } else {
                                set.add(props.value);
                            }
                            field.onChange(field.name)(Array.from(set));
                            form.setFieldTouched(field.name, true);
                        }}
                    />
                </label>
            )}
        </Field>
    );
}

export default VoaFilter;
